import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Preserves path when redirecting legacy root routes to the dashboard app.
 * e.g. /employee-suite/staff-users → /dashboard/employee-suite/staff-users
 */
export const LegacyToDashboardRedirect: React.FC = () => {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={`/dashboard${pathname}${search}${hash}`} replace />;
};
